import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const FileJSONGrayIcon = (options?: IconOptions) => {
  return (
    <svg
      width='36'
      height='40'
      viewBox='0 0 36 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...options.iconProps}
    >
      <path
        d='M4.66602 36.6666V1.66659L6.66602 0.333252L27.3327 0.666585V6.33325L28.3327 7.33325L33.9993 7.66659L34.3327 7.99992V35.6666L33.3327 37.3333L4.66602 36.6666Z'
        fill='white'
      />
      <path
        d='M27.333 6.33333V1.33333L27.6663 1L33.9997 7V7.66667H30.6663L28.333 7.33333L27.333 6.33333Z'
        fill='#FAFBFC'
      />
      <path
        d='M34.333 7.5V34.5C34.333 36.1569 32.9899 37.5 31.333 37.5H7.33301C5.67615 37.5 4.33301 36.1569 4.33301 34.5V3.5C4.33301 1.84315 5.67615 0.5 7.33301 0.5H27.333M34.333 7.5L27.333 0.5M34.333 7.5H30.333C28.6762 7.5 27.333 6.15685 27.333 4.5V0.5'
        stroke='#DFE0EB'
        strokeWidth='1.5'
      />
      <path
        d='M14.833 20.4998H20.1663'
        stroke='#DFE0EB'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.833 24.2341H21.833'
        stroke='#DFE0EB'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.833 22.3669H23.4997'
        stroke='#DFE0EB'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <mask id='path-7-inside-1_8549_3226' fill='white'>
        <rect x='14' y='13.1665' width='10.6667' height='5.33333' rx='1' />
      </mask>
      <rect
        x='14'
        y='13.1665'
        width='10.6667'
        height='5.33333'
        rx='1'
        stroke='#DFE0EB'
        strokeWidth='3'
        mask='url(#path-7-inside-1_8549_3226)'
      />
      <rect y='27.9998' width='29' height='12' rx='2' fill='white' />
      <rect y='27.9998' width='29' height='12' rx='2' fill='#6E798C' fillOpacity='0.4' />
      <path
        d='M5.46285 30.4543H6.63898V35.0566C6.63685 35.4784 6.54736 35.8417 6.37052 36.1464C6.19367 36.449 5.94651 36.6823 5.62904 36.8463C5.3137 37.0083 4.94616 37.0892 4.52641 37.0892C4.14289 37.0892 3.79772 37.0211 3.4909 36.8847C3.18621 36.7462 2.94438 36.5417 2.7654 36.2711C2.58643 36.0005 2.49694 35.6638 2.49694 35.2611H3.67627C3.6784 35.438 3.71675 35.5903 3.79133 35.7182C3.86803 35.846 3.9735 35.944 4.10773 36.0122C4.24197 36.0804 4.39644 36.1145 4.57116 36.1145C4.76079 36.1145 4.92165 36.075 5.05376 35.9962C5.18586 35.9152 5.286 35.7959 5.35418 35.6383C5.42449 35.4806 5.46072 35.2867 5.46285 35.0566V30.4543ZM11.4826 32.2537C11.4527 31.9745 11.327 31.7572 11.1054 31.6017C10.886 31.4461 10.6005 31.3684 10.2489 31.3684C10.0017 31.3684 9.78973 31.4057 9.61288 31.4802C9.43604 31.5548 9.30074 31.656 9.20699 31.7838C9.11324 31.9117 9.0653 32.0576 9.06317 32.2217C9.06317 32.3581 9.09406 32.4763 9.15585 32.5765C9.21977 32.6766 9.30606 32.7618 9.41473 32.8321C9.52339 32.9003 9.64378 32.9579 9.77588 33.0047C9.90798 33.0516 10.0411 33.091 10.1754 33.123L10.789 33.2764C11.0362 33.3339 11.2737 33.4117 11.5017 33.5097C11.7318 33.6077 11.9375 33.7313 12.1186 33.8804C12.3018 34.0296 12.4467 34.2096 12.5532 34.4206C12.6598 34.6315 12.713 34.8787 12.713 35.162C12.713 35.5456 12.615 35.8833 12.419 36.1752C12.223 36.465 11.9396 36.6919 11.5688 36.8559C11.2002 37.0179 10.7539 37.0988 10.2297 37.0988C9.72048 37.0988 9.27836 37.02 8.90336 36.8623C8.5305 36.7047 8.23859 36.4745 8.02765 36.172C7.81885 35.8694 7.70592 35.5008 7.68888 35.0662H8.85542C8.87247 35.2941 8.94278 35.4838 9.06636 35.6351C9.18994 35.7863 9.35081 35.8993 9.54896 35.9738C9.74925 36.0484 9.97297 36.0857 10.2201 36.0857C10.4779 36.0857 10.7038 36.0473 10.8977 35.9706C11.0937 35.8918 11.2471 35.7831 11.3579 35.6446C11.4687 35.504 11.5252 35.34 11.5273 35.1525C11.5252 34.982 11.4751 34.8414 11.3771 34.7306C11.2791 34.6177 11.1416 34.5239 10.9648 34.4493C10.7901 34.3726 10.5855 34.3044 10.3512 34.2448L9.60649 34.053C9.06743 33.9145 8.64129 33.7047 8.32808 33.4234C8.017 33.14 7.86146 32.764 7.86146 32.2952C7.86146 31.9096 7.96586 31.5718 8.17467 31.2821C8.38561 30.9923 8.67219 30.7675 9.0344 30.6077C9.39662 30.4458 9.80677 30.3648 10.2649 30.3648C10.7294 30.3648 11.1363 30.4458 11.4858 30.6077C11.8373 30.7675 12.1132 30.9902 12.3135 31.2757C12.5138 31.5591 12.6171 31.8851 12.6235 32.2537H11.4826ZM19.6188 33.727C19.6188 34.4323 19.4867 35.0363 19.2225 35.5392C18.9604 36.0399 18.6025 36.4234 18.1487 36.6897C17.697 36.9561 17.1845 37.0892 16.6114 37.0892C16.0382 37.0892 15.5247 36.9561 15.0709 36.6897C14.6192 36.4213 14.2612 36.0367 13.997 35.536C13.735 35.0331 13.6039 34.4302 13.6039 33.727C13.6039 33.0218 13.735 32.4188 13.997 31.9181C14.2612 31.4152 14.6192 31.0307 15.0709 30.7643C15.5247 30.498 16.0382 30.3648 16.6114 30.3648C17.1845 30.3648 17.697 30.498 18.1487 30.7643C18.6025 31.0307 18.9604 31.4152 19.2225 31.9181C19.4867 32.4188 19.6188 33.0218 19.6188 33.727ZM18.4267 33.727C18.4267 33.2306 18.3489 32.8119 18.1934 32.471C18.04 32.128 17.8269 31.8691 17.5542 31.6944C17.2815 31.5175 16.9672 31.4291 16.6114 31.4291C16.2555 31.4291 15.9413 31.5175 15.6685 31.6944C15.3958 31.8691 15.1817 32.128 15.0261 32.471C14.8727 32.8119 14.796 33.2306 14.796 33.727C14.796 34.2235 14.8727 34.6432 15.0261 34.9863C15.1817 35.3272 15.3958 35.586 15.6685 35.7629C15.9413 35.9376 16.2555 36.025 16.6114 36.025C16.9672 36.025 17.2815 35.9376 17.5542 35.7629C17.8269 35.586 18.04 35.3272 18.1934 34.9863C18.3489 34.6432 18.4267 34.2235 18.4267 33.727ZM26.1187 30.4543V36.9998H25.0641L21.9799 32.5413H21.9256V36.9998H20.7398V30.4543H21.8009L24.8819 34.9159H24.9394V30.4543H26.1187Z'
        fill='white'
      />
    </svg>
  );
};

export default FileJSONGrayIcon;
